const valiNumberPass1 = (rule, value, callback) => {
  //包含小数的数字
  let reg = /^(0|([1-9]\d*))(\.\d+)?$/g;
  if (value === "") {
    callback(new Error("请输入内容"));
  } else if (!reg.test(value)) {
    callback(new Error("请输入数字"));
  } else {
    callback();
  }
};

const zimu_shuzi = { reg: /^[0-9a-zA-Z]*$/g, msg: "请输入合法字符" };
const zuo_ji = { reg: /^\d{3}-\d{8}|\d{4}-\d{7,8}/g, msg: "请输入正确座机号" };
const phone_reg = {
  reg: /^(13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/g,
  msg: "请输入正确手机号",
};
const userName_reg = { reg: /^[\u4e00-\u9fa5]{0,5}$/g, msg: "请输入合法姓名" };
const ip_reg = {
  reg: /^((25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))$/g,
  msg: "请输入正确IP地址",
};
const num_reg = { reg: /^[0-9]*$/g, msg: "请输入数字" };
const xiao_shu = { reg: /^\d+(\.\d+)?$/g, msg: "请输入数字" };
const xiao_shu1 = { reg: /^\d+(\.\d{1})?$/g, msg: "请输入数字或一位小数" };
const str_16_reg = { reg: /^[A-Fa-f0-9]+$/g, msg: "请输入正确的十六进制数" };
const BaleNo_reg = { reg: /^[1-9]{6}$/g, msg: "请输入合法类型" };
const CottonKind_reg = {
  reg: /^0[0-9]{2}$/g,
  msg: "请输入合法类型",
};
export const bt = { required: true, trigger: "blur", message: "请输入" };
export const st = { required: true, trigger: "blur", message: "请选择" };
function regObj(data) {
  return {
    pattern: data.reg,
    message: data.msg,
  };
}
function regFun(data) {
  return { validator: data, trigger: "blur" };
}
export const nnc = [bt];
export const xh = [bt];
export const zbcode = [bt];
export const ypcode = [bt];
export const phone = [regObj(phone_reg)];
export const username = [regObj(userName_reg)];
export const ipaddress = [bt, regObj(ip_reg)];
export const hostaddress = [bt, regObj(num_reg)];
export const jd = [bt, regObj(xiao_shu)];
export const wd = [bt, regObj(xiao_shu)];
export const Tare = [regObj(xiao_shu1)];
export const xiaoShu = [bt, regFun(valiNumberPass1)];
export const LectronicWeigherIP = [regObj(ip_reg)];
export const LectronicWeigherIPPort = [regObj(num_reg)];
export const ScreenIP = [regObj(ip_reg)];
export const ScreenPort = [regObj(num_reg)];
export const PhotoelectricDeviceIP = [regObj(ip_reg)];
export const PhotoelectricDeviceIPPort = [regObj(num_reg)];
export const BranderIP = [regObj(ip_reg)];
export const BranderPort = [regObj(num_reg)];
export const str_16 = [regObj(str_16_reg)];
export const CottonKind = [regObj(CottonKind_reg)];
export const BaleNo = [];
export const versionTag = [bt];
export default {
  nnc,
  xh,
  zbcode,
  ypcode,
  phone,
  username,
  ipaddress,
  hostaddress,
  jd,
  wd,
  Tare,
  LectronicWeigherIP,
  LectronicWeigherIPPort,
  ScreenIP,
  ScreenPort,
  PhotoelectricDeviceIP,
  PhotoelectricDeviceIPPort,
  BranderIP,
  BranderPort,
  str_16,
  CottonKind,
  BaleNo,
  versionTag,
  xiaoShu,
};
